<template>
  <div>
    <v-expand-transition v-for="(doc, index) in matter.caseDocs.initialDocs" :key="index">
      <v-card
        style="background-color: black; border-radius: 26px; border: 1px solid #18CAE6; height:50px"
        class="ma-2"
      >
        <v-row>
          <v-flex>
            <v-card-text
              class="title white--text font-weight-light"
              style="border-radius: 26px; "
            >{{ doc.name }}</v-card-text>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex>
            <v-btn class="ma-3" small rounded text outlined color="yellow" @click="openDoc(doc)">
              <!-- <v-icon>mdi-view</v-icon> -->
              view
            </v-btn>
            <v-btn
              class="ma-3"
              small
              rounded
              text
              outlined
              color="red"
              @click="deleteInitialDoc(doc)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-flex>
        </v-row>
      </v-card>
    </v-expand-transition>
  </div>
</template>

<script>
/**
 * THIS COMPONENT SHOWS A LIST OF INITIAL DOCS UPLOADED BUY THE USER
 * ALSO ALLOWS USER TO DELETE THE DOCUMENTS
 */
import firebase from "firebase";
export default {
  props: ["matter", "user"],
  data() {
    return {
      initialDocs: this.matter.caseDocs.initialDocs,
    };
  },
  // computed: {
  //   initialDocs() {
  //     return this.$store.getters.initialDocs;
  //   }
  // },
  // watch: {
  //   initialDocs(value) {
  //     if (value !== null && value !== undefined) {
  //       console.log("initial docs watcher", value);
  //     }
  //   }
  // },
  methods: {
    openDoc(doc) {
      window.open(doc.url, "_blank");
    },
    deleteInitialDoc(doc) {
      const index = this.matter.caseDocs.initialDocs.indexOf(doc);
      const docName = doc.name;

      //set initdocs to new array
      let newArray = Array.from(this.matter.caseDocs.initialDocs);

      //remove the doc from the array
      newArray.splice(index, 1);
      console.log("newArray", newArray);
      console.log("oldArray", this.initialDocs);
      //save the new array to database as an update

      let ref = firebase
        .storage()
        .ref(
          `firms/${this.user.firmSlug}/matters/${this.matter.matterSlug}/initial_docs/${docName}`
        );
      ref
        .delete()
        .then(() => {
          console.log("storage document deleted");
          firebase
            .firestore()
            // .collection("firms")
            // .doc(this.user.firmSlug)
            .collection("matters")
            .doc(this.matter.matterSlug)
            //experimental
            .update({ "caseDocs.initialDocs": newArray })
            .then(() => {
              console.log("Document successfully updated!");
            })
            .catch((e) => console.log(e));
          // .collection("caseDocs")
          // .doc("initialDocs")
          // .update({ initialDocUrls: newArray })
          // .then(() => {
          //   console.log("Document successfully updated!");
          // });
        })
        .catch((e) => console.log(e));
    },
  },
  // created() {
  //   let payload = {
  //     firmSlug: this.user.firmSlug,
  //     matterSlug: this.matter.matterSlug
  //   };
  //   this.$store.dispatch("getInitialDocs", payload);
  // }
};
</script>

<style lang="scss" scoped></style>
